import * as React from "react";
import {
  Grid,
  Box,
  CircularProgress,
  Backdrop,
  List,
  Chip,
  ListItem,
  ListItemText,
} from "@mui/material";
import SummarizeIcon from "@mui/icons-material/Summarize";
// import CloseIcon from '@mui/icons-material/Close';
import { useContext, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PreferencesContext } from "../PreferencesContext";
import "../Theme/main.scss";
import { AlertType } from "../shared/Modal/AlertType";
import { TAX_INVOICE_TEMPLATE } from "../StaticData/DataHelper";
import { UpdateDefaultInvoice } from "../Services/UserService";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function InvoiceTemplateSelection(props: any) {
  const matches = useMediaQuery("(max-width:1135px)");
  const [isLoading, setLoading] = React.useState(false);

  const { userContext, updateUserContext } =
    React.useContext(PreferencesContext);

  const handleListItemInvoiceTemplateClick = (item: any) => {
    props.onselect(item?.value); //call child class to parent class with help of props
  };

  const handleSetDefaultTemplate = async (value: any) => {
    let saveUpdateTemplate = {
      userId: userContext?.userId.toString(),
      consumerId: userContext?.consumerId.toString(),
      defaultInvoice: value,
      ForPage: "SALE",
    };

    if (userContext?.userId > 0) {
      try {
        const resultUserUpdate: any = await UpdateDefaultInvoice(
          saveUpdateTemplate
        );
        if (resultUserUpdate.data === true) {
          updateUserContext({
            ...userContext,
            isAlert: true,
            defaultInvoice: value,
            alertMessage: resultUserUpdate.message,
            alertType: AlertType.Success,
          });
          // navigate(-1);
        } else {
          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage: resultUserUpdate.message,
            alertType: AlertType.Error,
          });
        }
      } catch (e: any) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage:
            typeof e === "string" ? (e as string) : (e?.message as string),
          alertType: AlertType.Error,
        });
      }
    } else {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Contact support team",
        alertType: AlertType.Error,
      });
    }
    props.onselect(value);
  };

  const filterTemplate = () => {
    let filteredTemplates: any;
    if ([41, 58, 5, 32, 76].includes(userContext.consumerId)) {
      filteredTemplates = TAX_INVOICE_TEMPLATE.filter(
        (x) => x.consumerId === userContext.consumerId
      );
    } else {
      filteredTemplates = TAX_INVOICE_TEMPLATE.filter(
        (x) => x.consumerId === userContext.consumerId || x.consumerId === 0
      );
    }

    if (userContext?.firmIndustryType !== "TRANSPORTATION") {
      filteredTemplates = filteredTemplates.filter(
        (x: any) => !x.value.startsWith("TransportInvoice")
      );
    }
    return filteredTemplates;
  };

  return (
    <>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Grid>
          <Box>
            <List>
              {filterTemplate().map((item: any, index) => {
                return (
                  // <h1>okko</h1>
                  <ListItem
                    className={
                      userContext?.defaultInvoice === item?.value
                        ? "financial-year-list-data selected"
                        : "financial-year-list-data"
                    }
                    disablePadding
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleListItemInvoiceTemplateClick(item);
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <SummarizeIcon className="icon-design-inpopup" />
                        <ListItemText primary={<b>{item?.label}</b>} />
                      </Box>
                    </Box>
                    <Box>
                      {userContext?.defaultInvoice === item?.value ? (
                        <Chip color="primary" label="Selected" />
                      ) : (
                        <FormControlLabel
                          label="Default"
                          control={
                            <Checkbox
                              checked={
                                userContext?.defaultInvoice === item?.value
                              }
                              value={item?.value}
                              onChange={(event) => {
                                event.stopPropagation();
                                handleSetDefaultTemplate(item?.value); // Call handleSetDefaultTemplate on checkbox click
                              }}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                        />
                      )}
                    </Box>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </Grid>
      </React.Fragment>
    </>
  );
}
